// The Add enquiry form's fixed dropdown lists — the fields the create
// endpoint takes as text rather than as an id.
//
// Title, Goal and Life style are not here: those three go up as ids, so they
// are fetched from the backend's own catalog. See `useEnquiryLookups`.

import type { EnquiryMode, EnquiryStatus } from "../types/enquiries.types";

export const GENDER_OPTIONS = ["Male", "Female", "Other"];

export const PROFESSION_OPTIONS = [
  "Working",
  "Self employed",
  "Student",
  "Homemaker",
  "Retired",
];

/**
 * How the enquiry reached the practice — the backend's `InquirySource`, in the
 * order it declares them and under the labels it gives them. The constant
 * behind each is what goes up (`Social media` as `SOCIAL_MEDIA`); see
 * `toEnquirySource`.
 *
 * A closed set: there is no way to enter a source the backend would refuse.
 * "Other" is not offered, because it is not one of these — it is only ever the
 * result of reading a constant this app has not been told about.
 */
export const ENQUIRY_FROM_OPTIONS: EnquiryMode[] = [
  "Social media",
  "Email",
  "Call",
  "Form",
];

/**
 * The stages an enquiry can be moved to — what the Change status dialog
 * offers. One list, read by both screens that offer the move, so the list page
 * and the detail page cannot come to disagree about the stages.
 *
 * Two of the five, and deliberately: "Recently Added" is where the backend opens
 * every enquiry and nothing moves one back to it, and "Payment sent" is what
 * raising a payment does — moving an enquiry there by hand would claim a
 * request that was never made. "Converted" is the backend's to give for the
 * same reason and a stronger one: it means the money arrived, which is not
 * something a dropdown should be able to assert. What is left is the judgement
 * this dialog is for: whether they are interested.
 */
export const ENQUIRY_STATUS_OPTIONS: EnquiryStatus[] = [
  "Interested",
  "Not interested",
];

// State and city are not here either: they come from `lib/locations`, the
// same real dataset the client address uses, narrowed to the state picked
// above them.
